import { render, staticRenderFns } from "./TruckForm.vue?vue&type=template&id=02819832&scoped=true"
import script from "./TruckForm.vue?vue&type=script&lang=js"
export * from "./TruckForm.vue?vue&type=script&lang=js"
import style0 from "./TruckForm.vue?vue&type=style&index=0&id=02819832&prod&lang=scss"
import style1 from "./TruckForm.vue?vue&type=style&index=1&id=02819832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02819832",
  null
  
)

export default component.exports